import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Calendar, User } from "lucide-react";
import api from "@/lib/api";
import useSeo from "@/lib/useSeo";
import RichText from "@/components/RichText";

export default function BlogDetail() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/public/blog/${slug}`).then((r) => setD(r.data)).catch(() => nav("/404", { replace: true }));
  }, [slug, nav]);
  useSeo(d ? { title: `${d.post.title} | Healthy Roots Blog`, description: d.post.seo?.description || d.post.excerpt, image: d.post.featured_image } : {});
  if (!d) return <div className="pt-40 text-center text-emerald-800">Loading…</div>;
  const p = d.post;
  return (
    <article className="pt-28 pb-24" data-testid="blog-detail">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-emerald-700 mb-6 hover:gap-3 transition-all"><ArrowLeft size={16} /> All Articles</Link>
        <div className="flex gap-2 mb-4">{(p.categories || []).map((c) => <span key={c} className="text-xs bg-emerald-50 text-emerald-700 px-3 py-1 rounded-full">{c}</span>)}</div>
        <h1 className="text-4xl sm:text-5xl text-emerald-950 mb-4">{p.title}</h1>
        <div className="flex items-center gap-4 text-sm text-stone-500 font-mono mb-8"><span className="flex items-center gap-1.5"><User size={14} /> {p.author}</span><span className="flex items-center gap-1.5"><Calendar size={14} /> {(p.published_at || "").slice(0, 10)}</span></div>
        {p.review && <div className="bg-amber-50 border border-amber-200 text-amber-800 rounded-xl px-4 py-3 text-sm mb-6">⚑ This article contains sample content for owner review.</div>}
        {p.featured_image && <img src={p.featured_image} alt={p.title} className="w-full rounded-3xl shadow-md mb-10 max-h-[460px] object-cover" />}
        <RichText html={p.content} />
        {d.related?.length > 0 && (
          <div className="mt-16"><h2 className="text-2xl text-emerald-900 mb-6">Related Articles</h2><div className="grid sm:grid-cols-3 gap-5">{d.related.map((x) => <Link key={x.id} to={`/blog/${x.slug}`} className="bg-white rounded-2xl overflow-hidden border border-stone-200/80 hover:shadow-md transition-all"><img src={x.featured_image} alt={x.title} className="h-32 w-full object-cover" /><p className="p-4 font-serif text-emerald-900 text-sm">{x.title}</p></Link>)}</div></div>
        )}
      </div>
    </article>
  );
}
